import { useEffect, useState } from "react";

/**
 * Breakpoint phân tách mobile / desktop.
 * - `max-width: 767px` → mobile dọc (khớp điểm Primer `<768px` = sm).
 * - `(max-height: 575px) and (orientation: landscape)` → điện thoại xoay ngang (cao ≤430px)
 *   vẫn dùng UI mobile thay vì bị nhồi vào layout desktop. iPad landscape cao 768px > 575
 *   nên KHÔNG trúng → giữ desktop fluid.
 */
const MOBILE_QUERY = "(max-width: 767px), (max-height: 575px) and (orientation: landscape)";

/**
 * Trả `true` khi viewport ở kích thước mobile. Lắng nghe resize/đổi orientation để
 * ClassesPage tự chuyển nhánh render desktop ↔ mobile mà không cần reload.
 */
export const useIsMobile = (): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(
        () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
    );

    useEffect(() => {
        const mql = window.matchMedia(MOBILE_QUERY);
        const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        mql.addEventListener("change", onChange);
        // Sync lần đầu phòng khi state khởi tạo trước khi mql sẵn sàng.
        setIsMobile(mql.matches);
        return () => mql.removeEventListener("change", onChange);
    }, []);

    return isMobile;
};
